import { render, staticRenderFns } from "./SmsIntegracoes.vue?vue&type=template&id=20884496&scoped=true&"
import script from "./SmsIntegracoes.vue?vue&type=script&lang=js&"
export * from "./SmsIntegracoes.vue?vue&type=script&lang=js&"
import style0 from "./SmsIntegracoes.vue?vue&type=style&index=0&id=20884496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20884496",
  null
  
)

export default component.exports